import { type BeamstarSession } from '@consigli/types';

export interface ProjectOption {
  /** `all`, `none` for the sessions started outside a project, or the project id. */
  value: string;
  label: string;
}

export const ALL_PROJECTS: ProjectOption = { value: 'all', label: 'All projects' };

const projectValue = (session: BeamstarSession) =>
  session.projectId === null ? 'none' : String(session.projectId);

/** Every project the sessions ran in, with its session count, the busiest first. */
export const projectOptions = (sessions: BeamstarSession[]): ProjectOption[] => {
  const counts = new Map<string, number>();
  for (const session of sessions) {
    const value = projectValue(session);
    counts.set(value, (counts.get(value) ?? 0) + 1);
  }
  const projects = [...counts.entries()]
    .sort(([, firstCount], [, secondCount]) => secondCount - firstCount)
    .map(([value, count]) => ({
      value,
      label: `${value === 'none' ? 'No project' : `Project ${value}`} (${count})`,
    }));
  return [ALL_PROJECTS, ...projects];
};

export const inProject = (sessions: BeamstarSession[], project: ProjectOption) =>
  project.value === ALL_PROJECTS.value
    ? sessions
    : sessions.filter((session) => projectValue(session) === project.value);
